export default "__VITE_ASSET__aQ2CzOfc__";